import React, { useState, useEffect } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import AsideTitle from '../asideTitle';
// import { getGoodArticle } from '@src/services/api';

const goodArticle = () => {
    // const [data, setData] = useState([]);

    // const getGoodArticleData = async () => {
    //     const data = await getGoodArticle();

    //     setData(data);
    // };

    // useEffect(() => {
    //     getGoodArticleData();
    // }, []);

    return (
        <div className={styles.goodArticleBox} id="hotbox-block">
            {/* <AsideTitle title="热门文章" />
            {data?.length > 0 ? (
                <div className={styles.goodArticle}>
                    {data.map((item, index) => (
                        <div className={styles.goodArticleItem} key={index}>
                            <a href={item.url} target="_blank">
                                <span className={styles.goodArticleNum}>{index < 9 ? `0${index + 1}` : index + 1}</span>
                                <span className={styles.goodArticleTitle}>{item.title}</span>
                            </a>
                        </div>
                    ))}
                </div>
            ) : (
                ''
            )} */}
        </div>
    );
};

export default errorBoundary(goodArticle);
